import { styled } from '@mui/material/styles';
import Link from 'next/link';

export const Wrapper = styled(Link)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
